
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"37","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('text',{attrs:{"transform":"translate(-45.5 -27.316)","fill":"#000","fill-rule":"evenodd","font-family":"AppleColorEmoji, Apple Color Emoji","font-size":"36","letter-spacing":"-.868"}},[_c('tspan',{attrs:{"x":"46","y":"61"}},[_v('😞')])])])
          )
        }
      }
    